import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { UserAccountFacade } from '@spartacus/user';
import { User } from '@user/const';
import { Subscription, timer } from 'rxjs';

@Directive({
  selector: '[sdPhoneAuthorizedUser]',
  standalone: true,
})
export class PhoneAuthorizedUserDirective implements AfterViewInit, OnDestroy {
  private subscription = new Subscription();

  constructor(
    private userAccountService: UserAccountFacade,
    private el: ElementRef,
    private fg: FormGroupDirective,
  ) {}

  ngAfterViewInit(): void {
    this.subscription.add(
      this.userAccountService.get().subscribe((user: User | undefined) => {
        if (user?.phone) {
          // С бэка приходит номер с ведущей семёркой, но при установке значения она и так уже есть как префикс
          this.setValue(user.phone.slice(-10));
        }
      }),
    );
  }

  setValue(value: string): void {
    const phoneField = this.fg.form.get('phone');

    if (!phoneField || phoneField.value) {
      return;
    }

    phoneField.setValue(value);

    timer(0).subscribe(() => {
      this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
